import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const colorPallete = {
  primary: {
    base: '#154734',
    darken1: '#123D2D',
    darken2: '#0F3325',
    darken3: '#0C291E',
    darken4: '#091F16',
    darken5: '#06140F',
    lighten1: '#298763',
    lighten2: '#227354',
    lighten3: '#41D99F',
    lighten4: '#49F2B1',
    lighten5: '#4DFFBB',
  },
};

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      dark: colorPallete,
      light: colorPallete,
    },
  },
});
